module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-users-tab.67971f45.png";